import { render } from "./SectionPartners.vue?vue&type=template&id=d983853a&scoped=true"
import script from "./SectionPartners.vue?vue&type=script&lang=js"
export * from "./SectionPartners.vue?vue&type=script&lang=js"

import "./SectionPartners.vue?vue&type=style&index=0&id=d983853a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d983853a"]])

export default __exports__